export function calculateBlankCardWidth(cardInfo, queryPropertyList, areaType, cardDom, isDragging) {
	if(cardInfo.blank) {

		if (areaType === 'form') {
			if (queryPropertyList.length === 0) {
				return '100%'
			}

			if (cardInfo.renderType === 'tableSide') {
				let needFillCount = 3 - (queryPropertyList.length % 3);

				//如果余数是0就需要占最小宽度
				return needFillCount === 3
					? '10px'
					: (needFillCount * 33) + '%'
			}

			let needFillCount = 4 - (queryPropertyList.length % 4);

			//如果余数是0就需要占最小宽度
			return needFillCount === 4
				? '10px'
				: (needFillCount * 25) + '%'

		}

		if (areaType === 'search') {
			if (queryPropertyList.length === 0) {
				return 16.6*5 + '%'
			}

			if (queryPropertyList.length < 6) {
				let needFillCount = 5 - (queryPropertyList.length % 5);

				return needFillCount === 5
					? '7%'
					: (needFillCount * 16.6) + '%'
			} else {
				let needFillCount = 6 - ((queryPropertyList.length - 5) % 6);
				return needFillCount === 6
					? '10px'
					: (needFillCount * 16.6) + '%'
			}

		}

		if (areaType === 'table' && cardDom && isDragging === false) {
			let parentDom = cardDom.parentElement;
			if (parentDom.className.includes('tile-view')){
				cardDom.style.display = 'none'
			}

			setTimeout(() => {
				if (parentDom.className.includes('tile-view')) {
					let lineCardNum = 6;
					let remainCardNum = (parentDom.childElementCount - 1) % lineCardNum;
					if (remainCardNum === 0) {
						cardDom.style.width = '5px'
					} else {
						let remianSpace = lineCardNum - remainCardNum;
						cardDom.style.width = remianSpace * 16.6 + '%'
					}
					cardDom.style.display = 'inline-block'

				} else if (parentDom.scrollWidth === parentDom.clientWidth) {
					if (cardDom.offsetWidth + cardDom.offsetLeft < parentDom.clientWidth) {
						cardDom.style.width = parentDom.clientWidth - cardDom.offsetLeft + 'px'
					} else {
						cardDom.style.width = '5px'
					}
				}
			});
			return '5px'
		}

	}
}
